import React from 'react'

const PromoCode = ({value, onPromoCodeChange, l}) => {
  return (
    <div>
      <label>{l.promo.label}</label>
      <div className='rw-widget rw-dropdownlist'>
        <input
          className='rw-input'
          type='text'
          value={value}
          onChange={onPromoCodeChange}
        />
      </div>
    </div>
  )
}

export default PromoCode



/** WEBPACK FOOTER **
 ** ./src/PromoCode.js
 **/